import React, { useState } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import ZoneOrderReportTable from "./ReportTable";
import ZoneSearchInput from "./SearchInput";

function OrdersTab() {
  const [searchValue, setSearchValue] = useState("");

  const updateSearchValue = (value) => {
    setSearchValue(value);
  };

  return (
    <div>
      <Container maxWidth={false}>
        <ZoneOrderReportTable
          searchInput={searchValue}
          updateSearchValue={updateSearchValue}
        />
      </Container>
    </div>
  );
}

export default OrdersTab;
